module.exports = __webpack_public_path__ + "img/flag.e179fe5b.svg";